var path = '/templates/users/views/directives/language_select_header.html';
var html = "<li class=dropdown dropdown><a class=dropdown-toggle dropdown-toggle><i class=\"fa fa-language\"></i> {{ getLanguageLabel() }}</a><ul class=dropdown-menu role=menu><li ng-repeat=\"lang in availableLanguages\"><a ng-click=setLanguage(lang)>{{ getLanguageLabel(lang, lang) }}</a></li></ul></li>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/users/views/directives/language_select_header.html
// module id = 1572
// module chunks = 0